"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.logger = void 0;
const log_handler_1 = require("./log.handler");
const log_sender_1 = require("./log.sender");
const logger_interface_1 = require("./logger.interface");
const utils_1 = require("./utils");
class Logger {
    set version(version) {
        this.config.version = version;
    }
    set merchantName(merchantName) {
        this._merchantName = merchantName;
        this.setSentryTag('merchantName', merchantName);
    }
    set fullStoryUrl(url) {
        this.setSentryTag('fullStoryUrl', url);
    }
    set sessionId(id) {
        this.config.sessionId = id;
        this.setSentryTag('sessionId', id);
        (0, log_handler_1.flushBuffer)(this.getConfig());
    }
    set origin(origin) {
        this.config.origin = origin;
        this.setSentryTag('origin', origin);
    }
    set browserSessionId(id) {
        this.config.browserSessionId = id;
        this.setSentryTag('browserSessionId', id);
        (0, log_handler_1.flushBuffer)(this.getConfig());
    }
    set deviceSessionId(id) {
        this.config.deviceSessionId = id;
        this.setSentryTag('deviceSessionId', id);
    }
    set correlationId(id) {
        this.config.correlationId = id;
        this.setSentryTag('correlationId', id);
    }
    constructor(config) {
        this.config = {
            production: false,
            appName: '',
            logsUrl: '',
        };
        this.isSentryInitialized = false;
        this._merchantName = '';
        this.isInitialized = false;
        this.getConfig = () => ({
            config: this.config,
            merchantName: this._merchantName,
            isInitialized: this.isInitialized,
        });
        this.log = (0, log_handler_1.makeLogHandler)(logger_interface_1.LogLevel.LOG, this.getConfig);
        this.info = (0, log_handler_1.makeLogHandler)(logger_interface_1.LogLevel.INFO, this.getConfig);
        this.warn = (0, log_handler_1.makeLogHandler)(logger_interface_1.LogLevel.WARN, this.getConfig);
        this.error = (0, log_handler_1.makeLogHandler)(logger_interface_1.LogLevel.ERROR, this.getConfig);
        this.group = (args) => {
            utils_1.refConsole.group('[ChargeAfter]', args);
        };
        this.groupCollapsed = (...args) => {
            utils_1.refConsole.groupCollapsed('[ChargeAfter]', ...args);
        };
        this.groupEnd = () => {
            utils_1.refConsole.groupEnd();
        };
        this.service = (serviceName) => {
            let version = '-1';
            const getServiceData = () => {
                return {
                    version,
                    service: serviceName,
                };
            };
            return {
                set version(_version) {
                    version = _version;
                },
                log: (0, utils_1.serviceWrapper)(getServiceData, this.log),
                info: (0, utils_1.serviceWrapper)(getServiceData, this.info),
                warn: (0, utils_1.serviceWrapper)(getServiceData, this.warn),
                error: (0, utils_1.serviceWrapper)(getServiceData, this.error),
            };
        };
        this.flush = () => {
            (0, log_handler_1.flushBuffer)(this.getConfig(), true);
        };
        this.getLogs = () => (0, log_sender_1.getLogs)();
        this.getServerUrl = () => this.config.logsUrl;
        if (config) {
            this.init(config);
        }
    }
    setSentryTag(tagName, value) {
        this.setSentryTags({ [tagName]: value });
    }
    setSentryTags(tags) {
        if (this.isSentryInitialized) {
            Promise.resolve().then(() => __importStar(require('./sentry.manager'))).then(({ setSentryTags }) => setSentryTags(tags));
        }
    }
    initSentry() {
        var _a, _b;
        if (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.sentryConfig) === null || _b === void 0 ? void 0 : _b.dsn) &&
            !/headless/.test(navigator.userAgent.toLowerCase())) {
            Promise.resolve().then(() => __importStar(require('./sentry.manager'))).then(({ initSentry }) => {
                if (this.config.sentryConfig) {
                    initSentry(this.config.sentryConfig);
                    this.isSentryInitialized = true;
                }
            });
        }
    }
    init(config) {
        this.config = config;
        this.initSentry();
        this.isInitialized = !!config;
        (0, utils_1.startInterceptingConsole)(config.appName);
    }
}
exports.Logger = Logger;
const logger = new Logger();
exports.logger = logger;
